import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Doc } from 'src/@types/docs';
import { DocsRequests } from 'src/requests/docs';
import { QueryKey } from 'src/utils/react-query';

export const useDocFavoriteMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: setFavorite, isLoading: isFavoritingDoc } = useMutation(
    async (id: string) => DocsRequests.favoriteDoc(id),
    {
      onSuccess(updatedDoc) {
        queryClient.setQueryData<Doc[]>([QueryKey.DOCS], (docs) =>
          docs?.map((doc) =>
            doc._id === updatedDoc._id ? { ...doc, starred: true } : doc,
          ),
        );
        queryClient.setQueryData<Doc>([QueryKey.DOC, updatedDoc._id], (doc) => {
          if (doc) {
            return { ...doc, starred: true };
          }
          return updatedDoc;
        });
      },
    },
  );

  const { mutateAsync: setDisfavor, isLoading: isDisfavoringDoc } = useMutation(
    async (id: string) => DocsRequests.unfavoriteDoc(id),
    {
      onSuccess(updatedDoc) {
        queryClient.setQueryData<Doc[]>([QueryKey.DOCS], (docs) =>
          docs?.map((doc) =>
            doc._id === updatedDoc._id ? { ...doc, starred: false } : doc,
          ),
        );
        queryClient.setQueryData<Doc>([QueryKey.DOC, updatedDoc._id], (doc) => {
          if (doc) {
            return { ...doc, starred: false };
          }
          return updatedDoc;
        });
      },
    },
  );

  return {
    setFavorite,
    isFavoritingDoc,
    setDisfavor,
    isDisfavoringDoc,
  };
};
